import { DWELL_DETAILED_VIEW_TABLE_COLUMNS } from "../commons/constants/CommonConstants";
import { getDwellPackageStatusFromPckStatusAndPckType } from "./CommonUtils";


export function getDataInCSVFormat(packageList) {
    const csvData = [];
    const columns = DWELL_DETAILED_VIEW_TABLE_COLUMNS;

    //header
    csvData.push(columns);

    //rows
    packageList.forEach(pckg => {
        const rowData = [];

        //DWELL TIME
        rowData.push(pckg.minutesInState);

        //TRACKING ID
        rowData.push(pckg.trackingId);

        //package State
        rowData.push(getDwellPackageStatusFromPckStatusAndPckType(pckg.state, pckg.packageType));

        // Route Code
        rowData.push(pckg.routeCode);

        //LAST SCAN TIME
        rowData.push(pckg.lastUpdatedTime);

        //ASSOCIATE
        rowData.push(pckg.lastScanBy);

        //LAST LOCATION
        rowData.push(pckg.lastScanLocation ? pckg.lastScanLocation : "")

        //PACKAGE SUB TYPE
        if (pckg.isGrocery) 
            rowData.push(pckg.isGrocery);

        csvData.push(rowData);
    });
    return csvData;
}


// WEBPACK FOOTER //
// ./src/util/ExportUtil.js